export default defineNuxtRouteMiddleware(async (to, from) => {
  const kissmetrics = useKissmetrics()
  await kissmetrics.identify()

  if (to.path !== from.path) {
    await kissmetrics.track('page_viewed', {
      page: to.path
    })
  }
})
